import Vue from 'vue'
import store from '@/plugins/store'
import { get } from 'lodash'

// Vue.filter('currency', (value, showDec = false) => {
//   const currencySymbol = store.getters.getCurrenySymbol || "$"
//   const decimalVal = showDec ? Number(value).toFixed(2) : ''+value
//   const val = decimalVal.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
//
//   return `${currencySymbol}${val}`
// })
// Vue.filter('toDollars', (value) => {
//   return value / 100 //this.currency(val / 100)
// })
//
// Vue.filter('phoneNumber', (raw) => {
//   if (raw) {
//     // Parse each section, adding 'pretty' values only on the left of where the user has typed
//     let area_code = raw.slice(0, 3) || ''
//     if (area_code) {
//       area_code = ' ('+area_code
//
//       if (area_code.length == 5)
//         area_code += ') '
//     }
//
//     let part_1 = raw.slice(3, 6) || ''
//     if (part_1 && part_1.length == 3)
//       part_1 += '-'
//
//     let part_2 = raw.slice(6, 10) || ''
//
//     return `${area_code}${part_1}${part_2}`
//   }
//
//   return null
// })
//
// Vue.filter('translate', (translations, value='value') => {
//   if (!translations)
//     return null
//
//   let lang = window.i18n.locale
//   // vuetify handles zh differently
//   if (lang === 'zhHans')
//     lang = 'zh'
//
//   // Look for the currently set translation
//   // Fallback on the first if the backend didn't provide the right translations
//   const currentTranslation = translations.find(translation => translation.lang == lang) || get(translations, '[0]', {})
//   return currentTranslation[value]
// })


Vue.use({
  install (Vue) {
    const currency = (value, showDec = false) => {
      const currencySymbol = store.getters.getCurrenySymbol || "$"
      const decimalVal = showDec ? Number(value).toFixed(2) : ''+value
      const val = decimalVal.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')

      return `${currencySymbol}${val}`
    }

    const toDollars = (value) => {
      return value / 100 //this.currency(val / 100)
    }

    const phoneNumber = (raw) => {
      if (raw) {
        // Parse each section, adding 'pretty' values only on the left of where the user has typed
        let area_code = raw.slice(0, 3) || ''
        if (area_code) {
          area_code = ' ('+area_code

          if (area_code.length == 5)
            area_code += ') '
        }

        let part_1 = raw.slice(3, 6) || ''
        if (part_1 && part_1.length == 3)
          part_1 += '-'

        let part_2 = raw.slice(6, 10) || ''

        return `${area_code}${part_1}${part_2}`
      }

      return null
    }

    const translate = (translations, value='value') => {
      if (!translations)
        return null

      if (typeof translations === 'string')
        return translations

      let lang = window.i18n.locale
      // vuetify handles zh differently
      if (lang === 'zhHans')
        lang = 'zh'

      // Look for the currently set translation
      // Fallback on the first language with a non empty value
      // Fallback on the first if the backend didn't provide the right translations
      const currentTranslation = translations.find(translation => translation.lang == lang && !!translation[value]) || translations.find(translation => !!translation[value]) || get(translations, '[0]', {})
      return currentTranslation[value]
    }

    // Gross way of declaring filters in a way that they are accessable in vuex modules
    Vue.prototype.$currency = currency
    Vue.prototype.$toDollars = toDollars
    Vue.prototype.$phoneNumber = phoneNumber
    Vue.prototype.$translate = translate

    Vue.filter('currency', currency);
    Vue.filter('toDollars', toDollars);
    Vue.filter('phoneNumber', phoneNumber);
    Vue.filter('translate', translate);
  }
})
